import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import { type LanTypes, getLanguageCode } from "@src/helpers";

export const API_URL = "/api/customer/expectedtransactiontypes";

interface ExpectedTransactionTypes {
  expectedTransactionsCode: string;
  defaultChecked?: boolean;
  expectedTransactionsID: number;
}

interface ExpectedTransactionTypesResponse {
  data: {
    expectedTransactionTypes: ExpectedTransactionTypes[];
  };
}

const getExpectedTransactionTypes = async (language: LanTypes) => {
  const languageCode = getLanguageCode(language);

  const response = await axiosInstance.get<ExpectedTransactionTypesResponse>(
    API_URL,
    {
      headers: { langcode: languageCode },
    }
  );
  return response.data;
};

export const useExpectedTransactionTypes = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  return useQuery({
    queryKey: [API_URL, i18n.language],
    queryFn: () => getExpectedTransactionTypes(i18n.language as LanTypes),
    onError() {
      navigate(`/${i18n.language}/error`);
    },
    staleTime: Infinity,
  });
};
